/**
 * Knowledge Base URLs organized by feature area.
 *
 * This file contains all help/documentation links for the application,
 * organized by feature area for easy maintenance and type safety.
 * The links can be found in Hubspot's Knowledge Base. https://hilfe.jupus.de/
 */

export interface KnowledgeBaseUrls {
  caseAiChat: string
  globalAiChat: string
  entities: string
  documents: string
  lawRelevantData: string
  general: string
  caseCreate: string
  phoneAi: string
}

/**
 * Knowledge base URLs for different feature areas.
 *
 * Update these URLs as needed when documentation locations change.
 */
export const KNOWLEDGE_BASE_URLS: KnowledgeBaseUrls = {
  caseAiChat: 'https://hilfe.jupus.de/was-ist-der-ki-chat',
  globalAiChat: 'https://hilfe.jupus.de/allgemeiner-ki-chat-',
  entities: 'https://hilfe.jupus.de/was-sind-beteiligte-',
  documents: 'https://hilfe.jupus.de/anleitung-f%C3%BCr-das-bearbeiten-von-pdfs',
  lawRelevantData: 'https://hilfe.jupus.de/was-sind-rechtsspezifische-daten',
  caseCreate: 'https://hilfe.jupus.de/manuelle-anlage-von-anfragen',
  phoneAi: 'https://hilfe.jupus.de/ki-anrufbeantworter',
  general: 'https://hilfe.jupus.de/' // Note: This URL is hardcoded in app/app/templates/base.html, Keep both locations in sync manually.
}

/**
 * Helper function to get a knowledge base URL by feature area.
 *
 * @param area - The feature area key
 * @returns The knowledge base URL for the specified area
 */
export function getKnowledgeBaseUrl(area: keyof KnowledgeBaseUrls): string {
  return KNOWLEDGE_BASE_URLS[area]
}
